var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditarBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_519",
    "data-name": "Grupo 519",
    transform: "translate(-2058 -1352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_339",
    "data-name": "Rect\\xE1ngulo 339",
    width: 22,
    height: 22,
    transform: "translate(2058 1352)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght300_GRAD0_opsz40",
    d: "M140.888-808.482h.778l7.921-7.914-.778-.778-7.921,7.914Zm-.335.887a.536.536,0,0,1-.395-.157.535.535,0,0,1-.157-.395v-1.018a1.081,1.081,0,0,1,.09-.432,1.09,1.09,0,0,1,.242-.355l9.383-9.384a1.009,1.009,0,0,1,.29-.183.879.879,0,0,1,.342-.068.9.9,0,0,1,.335.064.932.932,0,0,1,.3.191l.769.772a.768.768,0,0,1,.193.3.986.986,0,0,1,.059.332.924.924,0,0,1-.065.339.894.894,0,0,1-.186.294l-9.391,9.372a1.089,1.089,0,0,1-.355.242,1.081,1.081,0,0,1-.432.09Zm10.561-10.346-.76-.755Zm-1.915,1.16-.389-.393.778.778Z",
    transform: "translate(1922.998 2176.588)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarBlanco);
export default __webpack_public_path__ + "static/media/editar_blanco.8dd2c9be5e7e3fe4021b14f1e3cced9e.svg";
export { ForwardRef as ReactComponent };